import React, { useEffect, useRef, useState } from 'react';
import { appInterceptor } from '../../../games/stw/methods/appInterceptors';

const measurementUnit = (value = '', props) => {
  const { app = false } = props;
  if (app) {
    appInterceptor('true', {
      type: 'GARMENT_MEASUREMENT',
      clicked: 'garment measurement',
      value
    });
  }
};

export default function ToggleButton(props) {
const [updateString, setUpdateString] = useState("");

  const handleToggle = (value) => {
    props.handleToggleInchCM(); // Trigger parent update first

    if (props.app) {
      measurementUnit(value, props);
    }

    // Delay setting live message so screen reader processes tab change first
    const label = value === 'in' ? "inches" : "centimeters";
    setTimeout(() => {
      setUpdateString(`Size has been reloaded in ${label}`);
    }, 300); // Delay slightly to avoid overlap with tab/focus changes
  };

  // Auto-clear update string after a few seconds
  useEffect(() => {
    if (updateString !== "") {
      const timer = setTimeout(() => setUpdateString(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [updateString]);

  return (
    <>
      {/* Hidden live region away from visual UI */}
      <div aria-live="polite" className="sr-only" role="status">
        {updateString}
      </div>
    <div className="toggle-container" role="tablist">
      
      <input
        type="radio"
        id="in"
        name="measurementToggle"
        role="tab"
        tabIndex={0}
        checked={props.inches}
        aria-selected={props.inches}
        onChange={() => handleToggle('in')}
        className="visually-hidden"
      />
      <label
        className={`toggle-container__in ${props.inches ? 'active' : 'inactive'}`}
       aria-hidden="true"
      >
        in
      </label>
      <label htmlFor="in" className='sr-only'>{props.measurementType ? `${props.measurementType} in inches` : 'in'}</label>
    

      <input
        type="radio"
        id="cm"
        name="measurementToggle"
        role="tab"
        tabIndex={0}
        checked={!props.inches}
        aria-selected={!props.inches}
        onChange={() => handleToggle('cm')}
        className="visually-hidden"
      />
      <label
        className={`toggle-container__cm ${!props.inches ? 'active' : 'inactive'}`}
        aria-hidden="true"
      >
        cm
      </label>
      <label htmlFor="cm" className='sr-only'>{props.measurementType ? `${props.measurementType} in centimeters` : 'cm'}</label>
    </div>
    </>
  );
}
